import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "my-4 d-flex",
  style: {"gap":"1rem"}
}
const _hoisted_2 = {
  style: {"width":"160px"},
  class: "ma-2"
}
const _hoisted_3 = { class: "text-left" }
const _hoisted_4 = { class: "text-left" }
const _hoisted_5 = { class: "text-left" }
const _hoisted_6 = {
  class: "d-flex align-center",
  style: {"gap":"0.5rem"}
}
const _hoisted_7 = { class: "my-4" }
const _hoisted_8 = { class: "my-4 d-flex align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_btn, {
        variant: "flat",
        color: "primary",
        onClick: _cache[0] || (_cache[0] = () => _ctx.isImportDialogOpen = true)
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('childDevelopment.importRecords')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_btn, {
        variant: "outlined",
        color: "primary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.exportFile('domainField')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('childDevelopment.exportDomainFields')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_btn, {
        variant: "outlined",
        color: "primary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.exportFile('fieldClass')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('childDevelopment.exportFieldClass')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_spacer)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_text_field, {
        "hide-details": "",
        density: "compact",
        variant: "outlined",
        type: "number",
        modelValue: _ctx.year,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.year) = $event)),
        suffix: _ctx.$t('childDevelopment.fiscalYear')
      }, null, 8, ["modelValue", "suffix"])
    ]),
    (_ctx.isFetching)
      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: 0,
          indeterminate: "",
          color: "primary"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_table, null, {
      default: _withCtx(() => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.$t('childDevelopment.className')), 1),
            _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t('childDevelopment.age')), 1),
            _cache[7] || (_cache[7] = _createElementVNode("th", null, null, -1)),
            _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t('childDevelopment.excelOutput')), 1)
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classes, (c) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: c.nurseryClass.classId
            }, [
              _createElementVNode("td", null, _toDisplayString(c.nurseryClass.className), 1),
              _createElementVNode("td", null, _toDisplayString(c.nurseryClass.childrenAge), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "outlined",
                  to: `/child-development/class/${_ctx.year}/${c.nurseryClass.classId}`
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('childDevelopment.edit')), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    rounded: "",
                    loading: _ctx.exportingClassId === c.nurseryClass.classId && _ctx.exportingType === 'development',
                    onClick: ($event: any) => (_ctx.exportChildDevelopment(c.nurseryClass.classId))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        class: "me-0",
                        size: "18"
                      }, {
                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                          _createTextVNode("mdi-file-excel-outline", -1)
                        ]))]),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('childDevelopment.exportDevelopmentSheet')), 1)
                    ]),
                    _: 1
                  }, 8, ["loading", "onClick"]),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    rounded: "",
                    loading: _ctx.exportingClassId === c.nurseryClass.classId && _ctx.exportingType === 'record',
                    onClick: ($event: any) => (_ctx.exportChildDevelopmentRecord(c.nurseryClass.classId))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        class: "me-0",
                        size: "18"
                      }, {
                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                          _createTextVNode("mdi-file-excel-outline", -1)
                        ]))]),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('childDevelopment.exportProgressRecord')), 1)
                    ]),
                    _: 1
                  }, 8, ["loading", "onClick"])
                ])
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      "max-width": "700",
      modelValue: _ctx.isImportDialogOpen,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isImportDialogOpen) = $event)),
      "onClick:outside": _ctx.closeImportDialog
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "pa-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_page_title, {
              value: _ctx.$t('childDevelopment.importDialog.title')
            }, null, 8, ["value"]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_v_file_input, {
                "truncate-length": "15",
                accept: ".csv",
                placeholder: _ctx.$t('childDevelopment.importDialog.selectFile'),
                modelValue: _ctx.importFile,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.importFile) = $event))
              }, null, 8, ["placeholder", "modelValue"])
            ]),
            _createVNode(_component_v_radio_group, {
              modelValue: _ctx.fileType,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.fileType) = $event)),
              inline: "",
              class: "my-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_radio, {
                  label: _ctx.$t('childDevelopment.importDialog.domainFieldCsv'),
                  value: "domainField"
                }, null, 8, ["label"]),
                _createVNode(_component_v_radio, {
                  label: _ctx.$t('childDevelopment.importDialog.fieldClassCsv'),
                  value: "fieldClass"
                }, null, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (_ctx.isImportProcessing)
              ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                  key: 0,
                  indeterminate: "",
                  color: "primary",
                  class: "my-4"
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "primary",
                variant: "flat",
                disabled: _ctx.isImportProcessing,
                onClick: _ctx.startImport
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('childDevelopment.importDialog.startImport')), 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]),
              _createVNode(_component_v_spacer)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "onClick:outside"])
  ]))
}